// eslint-disable-next-line @typescript-eslint/no-var-requires
const THREE = require('three');

const addPickedEvents = function (setPickPosition, zoomOnPickPosition, clearPickPosition) {
  window.addEventListener('mousemove', setPickPosition);
  window.addEventListener('dblclick', zoomOnPickPosition);
  window.addEventListener('mouseout', clearPickPosition);
  window.addEventListener('mouseleave', clearPickPosition);

  window.addEventListener(
    'touchstart',
    event => {
      // prevent the window from scrolling
      event.preventDefault();
      setPickPosition(event.touches[0]);
    },
    { passive: false },
  );

  window.addEventListener('touchmove', event => {
    setPickPosition(event.touches[0]);
  });

  window.addEventListener('touchend', clearPickPosition);
};

class PickHelper {
  constructor(setPickPosition, zoomOnPickPosition, clearPickPosition, flash) {
    this.raycaster = new THREE.Raycaster();
    this.pickedObject = null;
    this.pickedObjectSavedColor = 0;
    this.flash = flash;
    this.pick = this.pick.bind(this);
    addPickedEvents(setPickPosition, zoomOnPickPosition, clearPickPosition);
  }

  pick(pickPosition, scene, camera, time) {
    // restore the color if there is a picked object
    if (this.pickedObject && this.pickedObject.material.emissive) {
      this.pickedObject.material.emissive.setHex(this.pickedObjectSavedColor);
      this.pickedObject = null;
    }

    // cast a ray through the frustum
    this.raycaster.setFromCamera(pickPosition, camera);
    // get the list of objects the ray intersected
    const intersectedObjects = this.raycaster.intersectObjects(scene.children, true);
    if (intersectedObjects.length) {
      // pick the first object. It's the closest one
      this.pickedObject = intersectedObjects[0].object;
      // return if it is a fake object
      if (!this.pickedObject.material.emissive) {
        return;
      }
      // save its color
      this.pickedObjectSavedColor = this.pickedObject.material.emissive.getHex();
      if (this.flash) {
        // set its emissive color to flashing white/seved color
        this.pickedObject.material.emissive.setHex((time * 4) % 2 > 1 ? 0xffffff : this.pickedObjectSavedColor);
      }
    }
  }
}

export { PickHelper };
